import { buildCartEntity } from '../utils/buildCartEntityUtils';
import { buildEgiftCard, buildGiftCard, getNavId, getSalesAttributes } from '../utils/cartUtils';

/**
 * Build Ajax POST Entity for Add to Cart
 * @param  {function} state     Redux state function
 * @param  {object} product     Product model
 * @return {object}             POST Entity
 */
export function getAddToCartEntity(state, product) {
    const currentWishlistId = _.get(state, 'wishlist.currentWishlist', null);
    const productSlug = _.get(product, 'product.productSlug', '');
    const navigationId = getNavId(state);
    const salesAttributes = getSalesAttributes(state, productSlug);
    const registryId = _.get(product, 'productRegistry.registry.hid', null);
    const isMarketPlace = _.get(product, 'product.isMarketPlace', false);
    const offerId = _.get(product, 'selectedSku.sku.offerId');

    return buildCartEntity({
        controls: product.productControls,
        sku: product.selectedSku.sku,
        eGiftCard: buildEgiftCard(product.product.isEgiftCard, product.productControls.validation),
        giftCard: buildGiftCard(product.product.isGiftCard, product.productControls.validation),
        giftWrap: product.giftWrap,
        registryId,
        currentWishlistId,
        navigationId,
        salesAttributes,
        isMarketPlace,
        offerId
    });
}

/**
 * Build Ajax POST Entity for Add to Wishlist
 * @param  {function} state     Redux state function
 * @param  {object} product     Product model
 * @return {object}             POST Entity
 */
export function getAddToWishlistEntity(state, product) {
    const productSlug = _.get(state, 'product.product.productSlug', '');
    const navigationId = getNavId(state);
    const salesAttributes = getSalesAttributes(state, productSlug);
    const currentWishlistId = _.get(state, 'wishlist.currentWishlist', null);
    const registryId = _.get(product, 'productRegistry.registry.hid', null);

    return buildCartEntity({
        controls: product.productControls,
        sku: product.selectedSku.sku,
        eGiftCard: buildEgiftCard(product.product.isEgiftCard, product.productControls.validation),
        giftCard: buildGiftCard(product.product.isGiftCard, product.productControls.validation),
        defaultStore: null,
        currentWishlistId,
        navigationId,
        salesAttributes,
        giftWrap: product.giftWrap,
        registryId: registryId
    });
}
